import React, {useState,useEffect} from 'react';
import {RouteComponentProps, Redirect, Link} from 'react-router-dom'//yarn add @types/react-router-dom
import useReactRouter from 'use-react-router';
import useStyles from './Styles';
import Hidden from '@mui/material/Hidden';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import FormControl from '@mui/material/FormControl';
import Badge from '@mui/material/Badge';
import Button from '@mui/material/Button';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import HelpIcon from '@mui/icons-material/Help';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import {Inc,Dataset,Owner,Item,ItemSearchCondition,Customer} from './Inc';
import {Tools} from './Tools';
import Ajax from './Ajax';
import Loading from './Loading';
import ItemListSearch from './ItemListSearch';
import ItemCheckTable from './ItemCheckTable';
import ItemLabelConfirm from './ItemLabelConfirm';
import ItemLabelIcon from './ItemLabelIcon';
import Toast from './Toast';
import Title from './Title';
import AppBank from './AppBank';

interface ItemLabelListProps {
	owner:Owner,
	bank:AppBank,
}

interface RCProps extends RouteComponentProps<{id:string}> {

}

const ItemLabelList = (props:ItemLabelListProps)=> {
	Ajax.setEditorId( props.owner.owner_id );
	const rcp:RCProps = useReactRouter();
	const labelId = parseInt(rcp.match.params.id as string);
	const currentLabel = Inc.itemLabels.find((label)=>{return label.id===labelId});

	const classes = useStyles();
	const defItems:Item[] = [];
	const defPages:Dataset[] = [];
	const defCheckedIds:number[] = [];
	const defCheckedItems:Item[] = [];
	const [states,setStates] = useState({
		items:defItems,
		checkedIds:defCheckedIds,
		checkedItems:defCheckedItems,
		isLoading:true,
		isFinished:false,
		modalPage:"",
		toast:"",
		currentPage:1,
		pager:null,
		cond:Inc.defaultItemSearchCondition(),
	});
	const [pages,setPages] = useState(defPages);
	const load = async()=>{
		await Ajax.send("item/labeled_list",{label_id:labelId},(res:any)=>{
			if( res.ok ){
				let checkedIds:number[] = [];
				let checkedItems:Item[] = [];
				if( res.items ){
					res.items.find( (item:Item)=>{
						checkedIds.push(item.item_id);
						checkedItems.push(item);
					});
					setStates(prev=>({...prev,checkedIds:checkedIds,checkedItems:checkedItems}));
				}
			}
		});
		await Ajax.send("item/pages",{},(res:any)=>{
			if( res.ok ){
				setPages(res.pages);
			}
		});
	}
	const search = (cond:ItemSearchCondition,page:number)=>{
		setStates(prev=>({...prev,"isLoading":true}));
		window.scrollTo(0,0);
		Ajax.search("item/list",cond,page,(res:any)=>{
			//console.log(res);
			if( res.ok ){
				setStates(prev=>({...prev,items:res.items,cond:cond,currentPage:page,pager:res.pager,isLoading:false}));
			} else {
				setStates(prev=>({...prev,"isLoading":false}));
			}
		});
	}
	const jump = (to:number)=>{
		search(states.cond,to);
	}
	const check = (e: React.MouseEvent<HTMLElement>)=>{
		if( !e.currentTarget.dataset.index ){
			return;
		}
		if( states.checkedIds.length>= (currentLabel?.max || 0) ){
			setStates(prev=>({...prev,"toast":"このラベルをつけられる商品は"+currentLabel?.max+"個までです"}));
			return;
		}
		const item = states.items[parseInt(e.currentTarget.dataset.index)];
		if( !states.checkedIds.includes(item.item_id) ){
			setStates(prev=>({...prev,"checkedItems":prev.checkedItems.concat(item),"checkedIds":prev.checkedIds.concat(item.item_id)}));
		}
	}
	const uncheck = (e: React.MouseEvent<HTMLElement>)=>{
		if( !e.currentTarget.dataset.index ){
			return;
		}
		const item = states.items[parseInt(e.currentTarget.dataset.index)];
		if( states.checkedIds.includes(item.item_id) ){
			let ids = states.checkedIds;
			const index1 = ids.findIndex((v) => v===item.item_id);
			ids.splice(index1,1);

			let items = states.checkedItems;
			const index2 = items.findIndex((v) => v.item_id===item.item_id);
			items.splice(index2,1);

			setStates(prev=>({...prev,"checkedItems":items,"checkedIds":ids}));
		}
	}
	const isChecked = (id:number)=>{
		return states.checkedIds.includes(id);
	}
	const input = ()=>{
		setStates(prev=>({...prev,"modalPage":"input"}));
	}
	const finish = ()=>{
		setStates(prev=>({...prev,"modalPage":"","isLoading":true}));
		let label = Inc.itemLabels.find( (label)=>{return label.id===labelId} )?.label;
		if( labelId===9 ) label = props.bank.get("freeLabel");
		
		Ajax.send("item/label",{label_id:labelId,item_ids:states.checkedIds,label:label},(res:any)=>{
			//console.log( res );
			if( res.ok ){
				// /labelにリダイレクトする
				setStates(prev=>({...prev,"isLoading":false,"isFinished":true}));
			} else {
				setStates(prev=>({...prev,"isLoading":false,"toast":"error"}));
			}
		})
	}
	const closeToast = ()=>{
		setStates(prev=>({...prev,"toast":""}));
	}
	const closeModal = ()=>{
		if( states.modalPage==="success" ){
			setStates(prev=>({...prev,"modalPage":"","checkedItems":defItems,"checkedIds":defCheckedIds,isFinished:true}));
		} else {
			setStates(prev=>({...prev,"modalPage":""}));
		}
	}
	const checkable = ()=>{
		return true;
	}
	useEffect( ()=>{
		load();
	},[]);

	if( states.isFinished ){
		return <Redirect to='/label'/>
	}
	if( props.owner.owner_id===0 ){
		return <Redirect to="/profile"/>
	}

	if(!currentLabel){
		return null;
	}

	return (
		<div id="item_list" className={classes.root}>
			<Grid container spacing={2}>
				<Grid item xs={12} md={8} lg={9}>
					<Paper className={classes.paper}>
						<Title text={"ラベル設定"} icon="cart"/>
						<div style={{display:'flex', gap:"0.5em"}}>
							<div style={{display:"flex", alignItems:"center",gap:"0.25em",border:"1px solid black", padding:"0 0.5em"}}>
								<ItemLabelIcon labelId={labelId}/>
								<span>{currentLabel.id===9 ? props.bank.get("freeLabel") : currentLabel.label}</span>
							</div>
							のラベルをつけられる商品は<span style={{margin:'0 0.5rem',fontSize:'150%',color:'teal'}}>{currentLabel?.max}</span>個までです。<br/>
						</div>
						<div style={{ marginBottom:"2em"}}>
							ラベルをつけたい商品を選んだら「商品の確認」を押して下さい。<br/>
							<Hidden mdUp implementation="js">
								<Grid container spacing={1} style={{marginTop:"1em"}}>
									<Grid item xs={6}><Button variant="text" color="primary" component={Link} to='/first/p5' startIcon={<HelpIcon/>}>ご利用ガイド</Button></Grid>
									<Grid item xs={6}>
									<div style={{textAlign:'right'}}>
										<Badge color="success" badgeContent={states.checkedIds.length}><Button variant="contained" color="primary" style={{width:"100%"}} onClick={input} disabled={states.checkedIds.length===0}><ShoppingCartIcon/>商品の確認</Button></Badge>
									</div>
									</Grid>
								</Grid>
							</Hidden>
						</div>

						<ItemCheckTable items={states.items} owner={props.owner} check={check} uncheck={uncheck} isChecked={isChecked} checkable={checkable}/>

						<div style={{padding:"1em"}}>
						{Tools.pager(states.pager,jump)}
						</div>
					</Paper>
				</Grid>
				<Grid item xs={12} md={4} lg={3}>
					<Hidden mdDown implementation="js">
						<Paper className={classes.paper} style={{marginBottom:"1em"}}>
							<Title text="商品を選んだら" size={2}/>
							<FormControl fullWidth={true}>
								<Badge color="success" badgeContent={states.checkedIds.length}><Button variant="contained" color="primary" style={{width:"100%"}} onClick={input} disabled={states.checkedIds.length===0}>
									<ShoppingCartIcon/>商品の確認
								</Button></Badge>
							</FormControl>
							<div style={{textAlign:'right'}}>
								<Button variant="text" color="primary" component={Link} to='/first/p5' startIcon={<ArrowForwardIcon/>}>ご利用ガイド</Button>
								<Button variant="text" color="primary" component={Link} to='/label' startIcon={<ArrowForwardIcon/>}>選ぶのをやめる</Button>
							</div>
						</Paper>
					</Hidden>

					<Paper className={classes.paper}>
						<ItemListSearch pages={pages} update={search}/>
					</Paper>
				</Grid>
			</Grid>

			<Loading isLoading={states.isLoading}/>
			<Toast mes={states.toast} close={closeToast}/>
			<ItemLabelConfirm isOpen={states.modalPage==="input"} label={currentLabel.id===9 ? props.bank.get("freeLabel") : currentLabel.label} labelId={labelId} finish={finish} close={closeModal} items={states.checkedItems}/>
		</div>
	);
}

export default ItemLabelList;
